import { useEffect, useState } from "react";
import { serverFetch } from "../../server";
import { Button, message, Popconfirm, Spin, Modal, Card, Typography } from "antd";
import "./visit-client.css";
import { fmtDate, fmtTimeHM } from "../../extensions/utils";
import Client from "../clients/client";
import TakePhoto from "../../controls/take-photo/take-photo";
import { isMobile } from "../../extensions/design";
import { ArrowLeftOutlined, EditOutlined } from "@ant-design/icons";
import UploadPhoto from "../../controls/take-photo/upload-photo";
import dayjs from "dayjs";

const { Text } = Typography;

const VisitClient = ({ id, onRefresh, onCloseVisit, onClose }) => {
  const [loading, setLoading] = useState(true);
  const [item, setItem] = useState();
  const [edit, setEdit] = useState(false);
  const [takePhoto, setTakePhoto] = useState(false);
  const [uploadPhoto, setUploadPhoto] = useState(false);
  const [showPhotoModal, setShowPhotoModal] = useState(false);

  const getData = () => {
    setLoading(true);
    serverFetch(`client/${id}`)
      .then(data => {
        setLoading(false);
        setItem(data);
      })
      .catch(e => {
        message.error(e.userMessage);
        setLoading(false);
      })
  }
  const closeMsg = item?.dolg ? "Закрыть визит с долгом?" : "Закрыть визит?";

  const onCloseClient = (refresh) => {
    setEdit(false);
    refresh && getData();
    onRefresh();
  }

  useEffect(getData, [id]);

  const onClosePhoto = (refresh) => {
    setTakePhoto(false);
    setUploadPhoto(false);
    refresh && getData();
  }

  const onSavePhoto = (file) => {
    const formData = new FormData();
    formData.append('file', file, file.name);
    serverFetch(`client/photo/${id}`, { method: "PUT", body: formData })
      .then(() => onClosePhoto(true))
      .catch(e => message.error(e.userMessage));
  }

  const onCloseUpload = (refresh) => {
    setUploadPhoto(false);
    refresh && getData();
  }

  const onDeletePhoto = () => {
    const formData = new FormData();
    serverFetch(`client/photo/${id}`, { method: "PUT", body: formData })
      .then(() => {
        const timestamp = Date.now();
        setItem((prev) => ({ ...prev, updatedAt: timestamp }));
        onClosePhoto(true);
      })
      .catch(e => message.error(e.userMessage));
  };

  return !isMobile ? <>
    <div className="visit-section">
      {loading ? <Spin /> : <div className="visit-client-main">
        <div className="visit-client-photo">
          <img src={item?.imageId ? `${process.env.REACT_APP_API_BASE_URL}/api/image/${item.imageId}.jpg` : "/images/sample.png"} alt="client" className="visit-client-photo-picture"/>
          <img src="/images/photo.svg" alt="take-photo" className="visit-client-photo-button autohide" onClick={() => setTakePhoto(true)}/>
          <img src="/images/upload-photo.svg" alt="take-photo" className="visit-client-photoload-button autohide" onClick={() => setUploadPhoto(true)}/>
          <Popconfirm title="Подтверждение" description="Удалить фото?" onConfirm={onDeletePhoto}>
          <img src="/images/photo-del.svg" alt="take-photo" className="visit-client-photodel-button autohide"/>
          </Popconfirm>
        </div>
        {takePhoto && <TakePhoto onClose={onClosePhoto} onSave={onSavePhoto}/>}
        {uploadPhoto && <UploadPhoto onClose={onCloseUpload} onSave={onSavePhoto}/>}
        <div className="visit-client-col">
          <div className="visit-client-row-btn-end">
            <div className="visit-client-name">{item.name}</div>
            {isMobile ? <Button shape="circle" icon={<EditOutlined />} onClick={() => setEdit(true)} /> : <Button onClick={() => setEdit(true)}>Изменить</Button>}
          </div>
          <div className="visit-client-row-2cols">
            <div><img src="/images/phone.svg" className="visit-client-img" alt="phone"/>{item.phone}</div>
            <div><img src="/images/cake.svg" className="visit-client-img" alt="cake"/>{fmtDate(item.dateBirth)}</div>
          </div>
          <div className="visit-client-row-2cols">
            <div><img src="/images/card.svg" className="visit-client-img" alt="card"/>{item.card}</div>
          </div>
          <div className="visit-client-row">
            <img src="/images/mail.svg" className="visit-client-img" alt="mail"/><div>{item.comment}</div>
          </div>
        </div>
      </div>}
    </div>
    {edit && <Client id={item.id} name={item.name} onClose={onCloseClient}/>}
  </> : <>
      {loading ? <Spin /> : item && (
        <div style={{ marginBottom: "8px" }}>
          <Card className="visit-item-card" style={{ padding: '4px', borderLeft: '4px solid #d9d9d9', borderRight: '4px solid #d9d9d9' }}>
            <div className="visit-item-card-name-debt" style={{ marginBottom: '4px' }}>
              <div style={{ display: "flex", alignItems: "center", gap: "6px", flex: 1 }}>
                <div
                  style={{ width: "32px", height: "32px", borderRadius: "50%", overflow: "hidden", flexShrink: 0, cursor: "pointer" }}
                  onClick={() => setShowPhotoModal(true)}
                >
                  <img
                    src={
                      item?.imageId
                        ? `${process.env.REACT_APP_API_BASE_URL}/api/image/${item.imageId}.jpg`
                        : "/images/sample.png"
                    }
                    alt="client"
                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                  />
                </div>
                <Text strong className="visit-item-clip" style={{ fontSize: '14px' }}>
                  {item.name}
                </Text>
              </div>
              <EditOutlined 
                style={{ fontSize: '16px', color: '#2f6f00', cursor: 'pointer' }}
                onClick={() => setEdit(true)}
              />
            </div>

            <div className="visit-item-info-fields" style={{ gap: '2px' }}>
              <div style={{ display: "flex", alignItems: "center" }}>
                <img src="/images/call.svg" alt="" style={{ width: 14, height: 14, marginRight: 4 }} />
                <Text className="visit-item-clip" style={{ fontSize: '12px' }}>{item?.phone}</Text>
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <img src="/images/card.svg" alt="" style={{ width: 14, height: 14, marginRight: 4 }} />
                <Text className="visit-item-clip" style={{ fontSize: '12px' }}>{item?.card}</Text>
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <img src="/images/birthday-cake.svg" alt="" style={{ width: 14, height: 14, marginRight: 4 }} />
                <Text className="visit-item-clip" style={{ fontSize: '12px' }}>{fmtDate(item?.dateBirth)}</Text>
              </div>
              {item?.comment && (
                <div style={{ display: "flex", alignItems: "center" }}>
                  <img src="/images/email.svg" alt="" style={{ width: 14, height: 14, marginRight: 4 }} />
                  <Text className="visit-item-clip-right" style={{ fontSize: '12px' }}>{item.comment}</Text>
                </div>
              )}
            </div>
          </Card>
        </div>
      )}
      <Modal title="Фото клиента" open={showPhotoModal}
        onCancel={() => setShowPhotoModal(false)} footer={null} centered width={300}
      >
        <div className="visit-photo-modal">
          <Button type="text" block className="visit-modal-photo" onClick={() => {setShowPhotoModal(false); setTakePhoto(true);}}>
            <img src="/images/photo.svg" alt="take-photo" style={{ width: "24px", height: "24px" }} />
            Сделать фото
          </Button>
          <Button type="text" block className="visit-modal-photo" onClick={() => { setShowPhotoModal(false); setUploadPhoto(true);}}>
            <img src="/images/upload-photo.svg" alt="upload-photo" style={{ width: "24px", height: "24px" }} />
            Загрузить фото
          </Button>
          <Popconfirm title="Подтверждение" description="Удалить фото?" onConfirm={() => { setShowPhotoModal(false); onDeletePhoto();}}
            okText="Да" cancelText="Нет" placement="top" getPopupContainer={(trigger) => trigger.closest('.visit-photo-modal')} overlayClassName="centered-popconfirm">
            <Button type="text" block className="visit-modal-photo">
              <img src="/images/photo-del.svg" alt="delete-photo" style={{ width: "24px", height: "24px" }} />
              Удалить фото
            </Button>
          </Popconfirm>
        </div>
      </Modal>
      {takePhoto && <TakePhoto onClose={onClosePhoto} onSave={onSavePhoto}/>}
      {uploadPhoto && <UploadPhoto onClose={onCloseUpload} onSave={onSavePhoto}/>}
      {edit && <Client id={item?.id} name={item?.name} onClose={onCloseClient}/>}
    </>
}

export default VisitClient;